import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog'

export interface DialogData {
    id: String
    slug: String
    title: String
    content: String
}

@Component({
    templateUrl: './dialog.html',
    styleUrls: ['./dialog.scss'],
})
export class DialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, public dialog: MatDialog) {}
}
